import React from 'react';
import classNames from 'classnames';
import { Row, Col, Nav, Tab } from 'react-bootstrap';

import styles from './VerticalNav.module.scss';

const VerticalNav = ({ links, comps, activeKey, setActiveKey, textCenter }) => {
  return (
    <div className={styles.vertical_nav}>
      <Tab.Container
        defaultActiveKey={activeKey}
        activeKey={activeKey}
        onSelect={(k) => setActiveKey(k)}
        className='mb-3'
      >
        <Row className={textCenter ?? null}>
          <Col lg={2} sm={12}>
            <Nav variant='pills' className='flex-column '>
              {links.map((elem) => (
                <Nav.Item className='navbar-nav ml-auto' key={`${elem.key}-left`}>
                  <Nav.Link
                    className={classNames(styles.vertical_nav__redLink, {
                      [styles.activeNav]: activeKey === elem.key,
                    })}
                    onClick={() => setActiveKey(elem.key)}
                    eventKey={elem.key}
                    data-test-id='vertical-nav'
                  >
                    {elem.label}
                  </Nav.Link>
                </Nav.Item>
              ))}
            </Nav>
          </Col>
          <Col lg={10} sm={12} className={'p-lg-4'}>
            <Tab.Content>
              {comps.map((c) => (
                <Tab.Pane eventKey={c.eventKey} key={`${c.eventKey}-right`}>
                  {c.comp}
                </Tab.Pane>
              ))}
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </div>
  );
};

export default VerticalNav;
